__webpack_require__.p = "http://rufa-dev.s3-website-us-west-1.amazonaws.com/";